import { useTheme } from '@emotion/react';
import StyledButton from '@components/Button';
import styled from '@emotion/styled';
import STRINGS from '@utils/strings';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router-dom';

const Container = styled.div(({ theme, hoverCursor }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    userSelect: 'none',
    transition: theme.transition.default,
    'button': {
        display: 'none'
    },
    '.btnContainer': {
        display: 'none'
    },
    '&:hover': {
        button: {
            display: 'inline-block'
        },
        '.btnContainer': {
            display: 'block'
        }
    },
    [theme.mediaQuery.largeMobileUp]: {
        margin: theme.spacing.xxs
    }
}));

const Image = styled.img(({ theme }) => ({
    paddingTop: theme.spacing.xxs,
    margin: theme.spacing.xxxs,
    width: theme.size.assetWidthTiny,
    objectFit: 'contain',
    [theme.mediaQuery.largeMobileUp]: {
        width: theme.size.assetWidth
    }
}));

const Video = styled.video(({ theme }) => ({
    paddingTop: theme.spacing.xxs,
    margin: theme.spacing.xxxs,
    width: theme.size.assetWidthTiny,
    objectFit: 'contain',
    [theme.mediaQuery.largeMobileUp]: {
        width: theme.size.assetWidth
    }
}));

const Badge = styled.span(({ theme }) => ({
    color: theme.colors.primary.contrastText,
    backgroundColor: theme.colors.primary.main,
    borderRadius: theme.borderRadius.l,
    width: theme.size.mintWidth,
    height: theme.size.mintHeight,
    top: 0,
    right: 0,
    textAlign: 'center',
    lineHeight: theme.size.mintHeight
}));

const Caption = styled.p(({ theme }) => ({
    color: theme.colors.common.black,
    marginTop: theme.spacing.xxxs,
    marginBottom: theme.spacing.xxxs,
    zIndex: 10
}));

const DisclaimerContainer = styled.div(() => ({
    position: 'absolute',
    display: 'flex',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
}));

const Disclaimer = styled.div(({ theme }) => ({
    color: theme.colors.common.black,
    backgroundColor: theme.colors.common.white,
    padding: theme.spacing.xxs,
    borderRadius: theme.borderRadius.s,
    width: '80%',
    textAlign: 'center',
    margin: 'auto'
}));

const ButtonContainer = styled.div(({ theme }) => ({
    position: 'absolute',
    bottom: theme.spacing.xs,
    right: 0,
    left: 0,
    width: isMobile ? '100%' : ''
}));

const NewItemContainer = styled.div(({ theme }) => ({
    background: theme.colors.primary.main,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    position: 'absolute',
    right: '-16px',
    top: theme.spacing.xs,
    width: theme.spacing.l,
    height: theme.spacing.l,
    textAlign: 'center',
    borderRadius: '2px',
    '&:before,&:after': {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        height: theme.spacing.l,
        width: theme.spacing.l,
        background: theme.colors.primary.main,
        borderRadius: '2px'
    },
    '&:before': {
        transform: 'rotate(30deg)'
    },
    '&:after': {
        transform: 'rotate(60deg)'
    }
}));

const NewItem = styled.p(({ theme }) => ({
    color: theme.colors.primary.contrastText,
    zIndex: '99',
    transform: 'rotate(30deg)'

}));

function GridItem({ id, mintNumber, srcImg, srcBackImg, badge, caption, onClick, buttons, templateId, recentlyOpened, hoverCursor='pointer', type = 'image' }) {
    const theme = useTheme();
    const location = useLocation();

    const ButtonStyle = {
        marginBottom: theme.spacing.xs,
        width: theme.size.gridItemButtonsWidth,
        display: isMobile ? 'block' : '',
        marginLeft: isMobile ? 'auto' : '',
        marginRight: isMobile ? 'auto' : ''
    };

    return (
        <Container onClick={() => onClick({ id, mintNumber, type, srcImg, srcBackImg, caption, badge, templateId })}>
            { badge ? <Badge>{badge}</Badge> : null }
            { badge && badge === '#?' ? <DisclaimerContainer><Disclaimer>{STRINGS.assetNotMintedDisclaimer}</Disclaimer></DisclaimerContainer> : null }
            { recentlyOpened && location.pathname === '/inventory' ? <NewItemContainer><NewItem>{STRINGS.recentItem}</NewItem></NewItemContainer> : null }
            { type === 'video' ?
                <Video muted autoPlay loop playsInline >
                    <source src={srcImg} type="video/mp4" />
                </Video>
                : <Image alt={caption} src={srcImg} />
            }
            { caption ? <Caption>{caption}</Caption> : null }
            { buttons ?
                <>
                    <ButtonContainer>
                        { buttons.map((button, index) => (
                            <StyledButton
                                key={index}
                                style={ButtonStyle}
                                onClick={(e) => {
                                    if (button.onClick) {
                                        e.stopPropagation();
                                        button.onClick({ id, mintNumber, type, srcImg, srcBackImg, caption, badge, templateId });
                                    }
                                }}
                            >
                                {button.label}
                            </StyledButton>
                        ))}
                    </ButtonContainer>
                </>
                : null }
        </Container>
    );
}

export default GridItem;
